import { TourStep } from 'app/tour/index';
import AppTour from 'app/tour/AppTour';

export default class TourStepLifeCycle {
    constructor(public appTour: AppTour) {}
    async onBeforeStart(step: TourStep, backward: boolean = false): Promise<any> {
        if (!step.waitForSelector) {
            return Promise.resolve(true);
        }
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                const element = document.querySelector(step.target);
                if (element) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, 100);
        });
    }
    async onBeforeClose(step: TourStep, backward: boolean = false): Promise<any> {
        return Promise.resolve(true);
    }
}
